import { render, staticRenderFns } from "./sustainability-rating-section.vue?vue&type=template&id=3055263a&scoped=true"
import script from "./sustainability-rating-section.vue?vue&type=script&lang=js"
export * from "./sustainability-rating-section.vue?vue&type=script&lang=js"
import style0 from "./sustainability-rating-section.vue?vue&type=style&index=0&id=3055263a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3055263a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3055263a')) {
      api.createRecord('3055263a', component.options)
    } else {
      api.reload('3055263a', component.options)
    }
    module.hot.accept("./sustainability-rating-section.vue?vue&type=template&id=3055263a&scoped=true", function () {
      api.rerender('3055263a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/supplier/sections/sustainability-rating-section.vue"
export default component.exports